<template>
  <YdDialog
    ref="sendCouponAdd"
    title="发放优惠券"
    :visible.sync="visible"
    :append-to-body="true"
    @close="closeDialog"
    width="68%"
  >
    <el-form ref="form" :model="form" size="small" :rules="rules">
      <el-form-item label="发放用户">
        <div style="display: flex; justify-content: space-between">
          <el-input
            :disabled="fromPage === 'user'"
            type="textarea"
            v-model="form.phonestr"
            :rows="4"
            style="width: 30vw"
            placeholder="请输入电话号码用','分割，例如：138***88,139***99"
            @change="onTextareaChange"
          />
          <span v-if="fromPage !== 'user'">
            <el-upload
              ref="fileUpload"
              :action="filePath"
              :on-success="handleUpload"
              multiple
              :limit="1"
              :headers="headers"
              accept=".xlsx, .xls"
              :data="{ code: 'activity' }"
              :file-list="userFileList"
            >
              <el-button size="small" type="primary">导入</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
              <div slot="tip" class="el-upload__tip" style="color: red">
                每次最多发送 10w 个用户
              </div>
            </el-upload>
          </span>
          <span v-if="fromPage !== 'user'">
            <el-button type="text" @click="handleDown">下载模版</el-button>
          </span>
        </div>
      </el-form-item>
      <el-form-item label="发券原因" prop="remark">
        <el-input type="textarea" v-model="form.remark" :rows="2" style="width: 30vw" />
      </el-form-item>

      <el-form-item label="是否发送到账通知" prop="notic">
        <el-switch v-model="form.notic" active-color="#13ce66" />
      </el-form-item>

      <el-form-item v-if="form.notic" label="通知方式" prop="noticList">
        <el-checkbox-group v-model="form.noticList">
          <el-checkbox @change="checkboxChange" :label="1">发送短信</el-checkbox>
          <el-checkbox :label="2">发送小程序服务通知</el-checkbox>
          <el-checkbox :label="3">乘客端展示优惠券到账弹窗</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="showUpImgDom" label="通知弹窗" prop="imgUrl">
        <el-upload
          ref="uploadRef"
          :action="doUpload"
          :headers="headers"
          name="file"
          list-type="picture-card"
          :before-upload="(file) => handleBeforeUpload(file, 640, 720)"
          :on-success="
            (response, file, fileList) => {
              return uploadSuccess(response, file, fileList)
            }
          "
          :on-error="handleUploadError"
          :on-remove="handleRemove"
          :file-list="fileList"
          :show-file-list="true"
          style="width: 100%"
          :data="{ code: 'activity' }"
          :class="{ disabled: uploadDisabled }"
        >
          <i class="el-icon-plus"></i>
          <div class="el-upload__tip" slot="tip">
            请上传大小不超过1MB,宽度640px，高度720px，格式为jpg/png
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <span>
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAddCoupon">
            添加优惠券/礼包
          </el-button>
        </span>
        <div style="padding-top: 10px">
          <el-table :data="couponItem" border size="mini" max-height="280px">
            <el-table-column label="优惠券名称" align="center" prop="giftName">
              <template slot-scope="scope">
                {{ scope.row.type === 1 ? scope.row.giftName : scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="优惠券类型" align="center" prop="type">
              <template slot-scope="scope">
                {{ scope.row.type === 1 ? '礼包' : '优惠券' }}
              </template>
            </el-table-column>
            <el-table-column label="优惠券金额" align="center" prop="discountsMoney" />
            <el-table-column label="剩余数量" align="center" prop="surplusNum" />
            <el-table-column label="发放数量" align="center" prop="num">
              <template slot-scope="scope">
                <avue-input-number v-model="scope.row.num" min-rows="0" style="width: 8vw" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="deletes(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="reset">取 消</el-button>
      <el-button type="primary" size="small" @click="handleSend" :loading="sendLoading">
        发 放
      </el-button>
      <span>已选择： {{ varMatch }}</span>
    </div>
    <select-coupon ref="selectCoupon" v-if="selectVisible" />
  </YdDialog>
</template>

<script>
  import { debounce } from 'lodash-es'
  import { addSendCoupon } from '@/api/marketing/activities-api'
  import env from '@/config/env'
  import { getToken } from '@/util/auth'
  import SelectCoupon from './select-coupon'
  export default {
    name: 'sendCouponAdd',
    components: {
      SelectCoupon
    },
    data() {
      return {
        userFileList: [],
        doUpload: env.uploadUrl + env.ferryUrl + '/oss/uploadV2',
        uploadDisabled: false,
        fileList: [],
        fromPage: '',
        visible: false,
        selectVisible: false,
        form: {
          phonestr: '',
          phone: [],
          remark: '',
          noticList: [],
          notic: false,
          imgUrl: '',
          sendSms: false,
          sendWxMsg: false,
          popUp: false
        },
        rules: {
          remark: [{ required: true, message: '请输入发券原因', trigger: 'blur' }],
          noticList: [{ required: true, message: '请选择通知方式', trigger: 'blur' }],
          imgUrl: [{ required: true, message: '请上传通知弹窗', trigger: 'blur' }]
        },
        phones: [],
        selections: [],
        filePath: env.uploadUrl + env.ferryUrl + '/activityCoupon/importPhone',
        headers: {
          Authorization: 'Bearer ' + getToken()
        },
        sendLoading: false
      }
    },
    watch: {
      varMatch(val) {
        return val
      }
    },
    computed: {
      showUpImgDom() {
        if (this.form.noticList.length > 0) {
          const v = this.form.noticList.findIndex((item) => item === 3)
          return v > -1
        } else {
          return false
        }
      },
      couponItem: {
        get() {
          return this.$store.state.coupon.couponItems
        },
        set(val) {
          this.$store.commit('UPDATE_SELECT_COUPON', val)
        }
      },

      varMatch() {
        let matchAmount = 0
        this.couponItem.forEach((item) => {
          matchAmount += item.discountsMoney * item.num
        })
        return this.strip(matchAmount, 2)
      }
    },
    methods: {
      checkboxChange(e) {
        if (e) {
          const that = this
          const v = that.form.noticList.findIndex((item) => item === 1)
          this.$confirm('是否确认发送短信？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {})
            .catch(() => {
              that.form.noticList.splice(v, 1)
            })
        }
      },
      handleRemove(file, fileList) {
        this.form.imgUrl = ''
        this.uploadDisabled = false
      },
      // 上传失败
      handleUploadError() {
        this.$loading().close()
        this.$modal.msgError('上传失败，请重试')
        this.uploadDisabled = false
      },
      uploadSuccess(res, file, fileList, type) {
        this.$loading().close()
        if (JSON.stringify(res.data) === '{}') {
          this.$message.warning({
            message: '请修改文件名后重新上传'
          })
          const index = this.$refs.uploadRef.uploadFiles.findIndex((e) => e.uid === file.uid)
          this.$refs.uploadRef.uploadFiles.splice(index, 1)
          this.uploadDisabled = false
          return
        }
        this.form.imgUrl = res.data.url
      },
      handleBeforeUpload(file, imgWidth, imgHeight) {
        return new Promise((resolve, reject) => {
          const uploadTypes = ['jpg', 'jpeg', 'png']
          const filetype = file.name.replace(/.+\./, '')
          if (uploadTypes.indexOf(filetype.toLowerCase()) === -1) {
            this.$message.warning({
              message: '请上传后缀名为jpg、jpeg、png的附件'
            })
            reject(new Error())
          }
          this.getImgSize(file).then((res) => {
            const { width, height } = res
            if (width !== imgWidth || height !== imgHeight) {
              this.$message.warning({
                message: '尺寸不符，请修改尺寸后重新上传！'
              })
              this.uploadDisabled = false
              reject(new Error())
            } else {
              this.$loading()
              this.uploadDisabled = true
              resolve()
            }
          })
          const isLt = file.size / 1024 / 1024 < 1
          if (!isLt) {
            this.$message.warning('上传图片大小不能超过1MB!')
          }
          // this.$loading()
          // this.uploadDisabled = true
        })
      },
      getImgSize(imgFile) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(imgFile)
          reader.onload = function () {
            const image = new Image()
            image.src = reader.result
            image.onload = function () {
              resolve({
                width: this.width,
                height: this.height,
                src: this.src
              })
            }
          }
        })
      },

      init(phoneStr, fromPage) {
        this.form.phonestr = phoneStr || ''
        this.phones = phoneStr ? phoneStr.split(',') : []
        this.fromPage = fromPage
        this.$refs.form && this.$refs.form.clearValidate()
        this.visible = true
      },
      reset() {
        this.$store.commit('REMOVE_SELECT_COUPON', [])
        this.form = {
          phonestr: '',
          phone: [],
          remark: '',
          notic: false,
          noticList: [],
          imgUrl: '',
          sendSms: false,
          sendWxMsg: false,
          popUp: false
        }
        this.phones = []
        this.selections = []
        this.$refs.fileUpload && this.$refs.fileUpload.clearFiles()
        this.visible = false
      },
      closeDialog() {
        this.reset()
      },
      onTextareaChange: debounce(function (event) {
        const errPhone = []
        const splitArr = event.split(/;|、|,|，| |\r|\n/)
        const resultArr = splitArr.map((el) => el.trim()).filter((item) => item.trim() !== '')
        resultArr.forEach((element, i) => {
          if (element.length !== 11) {
            errPhone.push(element)
            this.$message.warning(`第${i + 1}条手机号码格式错误`)
          }
        })
        this.phones = errPhone.length ? [] : resultArr
      }, 800),
      handleSend() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit()
          }
        })
      },
      submit() {
        if (!this.phones.length) {
          this.$message.error('发放用户手机号码未录入或者有误')
          return
        }
        let sendSms = false
        let sendWxMsg = false
        let popUp = false
        if (this.form.notic) {
          sendSms = this.form.noticList.findIndex((item) => item === 1)
          sendWxMsg = this.form.noticList.findIndex((item) => item === 2)
          popUp = this.form.noticList.findIndex((item) => item === 3)
          this.form.sendSms = sendSms > -1
          this.form.sendWxMsg = sendWxMsg > -1
          this.form.popUp = popUp > -1
        } else {
          this.form.sendSms = false
          this.form.sendWxMsg = false
          this.form.popUp = false
        }

        this.form.giftAndCouponList = this.couponItem
        this.form.phone = this.phones
        this.form.phonestr = this.phones.join(',')
        this.sendLoading = true

        addSendCoupon(this.form)
          .then((resp) => {
            if (resp.code === 0) {
              this.$message.success('创建成功')
              this.reset()
              this.$emit('refreshDataList')
            }
          })
          .finally(() => {
            this.sendLoading = false
          })
      },
      handleAddCoupon() {
        this.selectVisible = true
        this.$nextTick(() => {
          this.$refs.selectCoupon.init()
        })
      },
      handleDown() {
        window.location.href = env.importExcelUrl + env.ferryUrl + '/activityCoupon/exportPhone'
      },
      handleUpload(response) {
        if (response.code === 0) {
          this.form.phonestr = response.data.join(',') + ','
          this.onTextareaChange(this.form.phonestr)
        } else {
          this.$set(this, 'userFileList', [])
          this.$message.error(response.msg)
        }
      },
      deletes(index) {
        this.$store.commit('DELETE_SELECT_COUPON', index)
      },
      strip(num, precision) {
        if (precision === undefined) {
          precision = 12
        }
        return +parseFloat(num.toPrecision(precision))
      }
    }
  }
</script>

<style scoped></style>
